import { DataHeader, DataSource, Layout, Panel, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutDispatchZone extends Layout {
    dataheaderDispatchZone: DataHeader;
    panelDispatchZone: Panel;
    sourceDispatchZone: DataSource;
    textboxDescription: Textbox;
    textboxId: Textbox;
    textboxZoneAreaId: Textbox;
}
